import {
  EXTERNAL_LINKS,
  REGISTRATION_ENABLED,
  SITE_URL,
  STORE_LINKS,
} from "~/lib/constants";

/** Registration is open; flip `REGISTRATION_ENABLED` in `constants.ts` to close it. */
export function isRegistrationEnabled(): boolean {
  return REGISTRATION_ENABLED;
}

/** Sign-in form defaults were an env-only convenience; config now lives in code, so they are blank. */
export function getDevAuthDefaults() {
  return { email: "", password: "", firstName: "", lastName: "" };
}

export function getStoreLinks() {
  return {
    ios: STORE_LINKS.ios,
    android: STORE_LINKS.android,
  };
}

export function getSiteUrl() {
  return SITE_URL;
}

export function getExternalLinks() {
  return { ...EXTERNAL_LINKS };
}
